<template>
  <iLink
    v-if="shouldShowLink"
    :href="platformUrl"
    v-bind="fullTextOptionsAttributes"
    :style-overrides="myStyleOverrides"
    :border-top="myBorderSides.top"
    :border-bottom="myBorderSides.bottom"
    :border-left="myBorderSides.left"
    :border-right="myBorderSides.right"
    target="_blank"
    rel="noopener noreferrer"
    :width="fullTextOptionsAttributes.width"
    :min-width="fullTextOptionsAttributes.minWith"
    :max-width="fullTextOptionsAttributes.maxWith"
    :background-position="getOptionValue(BackgroundPosition)"
    :background-size="getOptionValue(BackgroundSize)"
    :background-repeat="getOptionValue(BackgroundRepeat)"
    :hover-background-position="getOptionValue(BackgroundPosition, BaseOption.$states.HOVER)"
    :hover-background-size="getOptionValue(BackgroundSize, BaseOption.$states.HOVER)"
    :hover-background-repeat="getOptionValue(BackgroundRepeat, BaseOption.$states.HOVER)"
  >
    <iRow
      align="center"
      gap="extraSmall"
      vertical-align="middle"
      wrap="nowrap"
    >
      <iIcon name="simple-icons:applepodcasts" :size="18" />
      <iText v-bind="textOnlyAttributes" :style-overrides="textOnlyAttributes.textStyleOverrides">
        Apple Podcasts
      </iText>
    </iRow>
  </iLink>
</template>

<script>
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";
import { EpisodePageElementMixin } from "%/dynamic-component-editor/standard-pages/episode-page/episode-page-element-mixin";

export default {
  name: "EpisodeApplePodcastsLink",
  elementPanelSettings: {
    displayName: "Apple Podcasts Link",
    displayIcon: "simple-icons:applepodcasts",
    elementGroup: "episode",
    elementType: "element",
  },
  extends: UrlElement,
  mixins: [EpisodePageElementMixin],
  computed: {
    platformUrl() {
      return this.entity.applePodcastsUrl;
    },
    shouldShowLink() {
      return Boolean(this.platformUrl) || this.editMode;
    },
  },
  styleGuide: () => ({
    linkBackgroundColor: { "color.background": "paper" },
    linkBorderColor: { "color.border": "light" },
    linkBorderRadius: { "size.borderRadius": "large" },
    linkPaddingVertical: { "size.spacing": "small" },
    linkPaddingHorizontal: { "size.spacing": "standard" },
  }),
};
</script>
